import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiGetMarque, apiSaveMarque, apiUpdateMarque } from "../../../api/ApiMarque";
import { useTranslation } from "react-i18next";
import ModalCropImage from "../../layout/ModalCropImage";
import { MdDelete } from "react-icons/md";

const initialState = {
  nom: "",
  marquePic: "",
  moduleTeams: false,
};

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;
  const [state, setState] = useState(initialState);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [croppedImage, setCroppedImage] = useState("");
  const [image, setImage] = useState("");
  const [showModalCrop, setShowModalCrop] = useState(false);

  const recupData = async () => {
    const res = await apiGetMarque(ReduxInstance._id, id);
    setState(res.data);
  };

  const submitData = async () => {
    const myForm = new FormData();
    Object.keys(state).forEach((key) => {
      if (Array.isArray(state[key])) {
        state[key].forEach((element) => {
          myForm.append(key + "[]", element);
        });
      } else {
        myForm.append(key, state[key]);
      }
    });
    if (image) {
      myForm.append("image", croppedImage);
    }

    if (id) {
      await apiUpdateMarque(id, myForm);
      setState(initialState);
      setCroppedImage("");
      handleRecupDatas();
    } else {
      await apiSaveMarque(ReduxInstance._id, myForm);
      setState(initialState);
      setCroppedImage("");
      handleRecupDatas();
    }
    handleClose();
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  const emptyImage = () => {
    setImage("");
    setCroppedImage("");
    setState({ ...state, marquePic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  useEffect(() => {
    if (id) recupData();
    else setState(initialState);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {id
            ? t("admin.PageAdminMarques.modalCreateEditTitre2")
            : t("admin.PageAdminMarques.modalCreateEditTitre1")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            placeholder={t("commun.form.placeholder.placeholder1")}
            value={state.nom}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          {croppedImage ? (
            <div>
              <div className="mt-2">{t("commun.form.label.logo")}</div>
              <Image src={URL.createObjectURL(croppedImage)} width={300} height={150} />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : state.marquePic ? (
            <div>
              <div className="mt-2">{t("commun.form.label.logo")}</div>
              <Image
                width={300}
                src={process.env.REACT_APP_URL_EXPRESS + "images/marque/" + state.marquePic}
              />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : (
            <div>
              <label className="mt-2">{t("commun.form.label.logo")}</label>
              <Form.Control type="file" accept="image/*" onChange={onSelectedFile} />
            </div>
          )}
          <ModalCropImage
            show={showModalCrop}
            image={image}
            handleClose={handleCloseCrop}
            resetImage={emptyImage}
            setImageCropped={setCroppedImage}
            xRatio={300}
            yRatio={150}
          />

          <label className="mt-3">{t("commun.form.label.intitule18")}</label>
          <Form.Check
            role="button"
            name={"moduleTeams"}
            type="switch"
            value={true}
            onChange={(e) => setState({ ...state, [e.target.name]: !state.moduleTeams })}
            checked={state.moduleTeams ? "checked" : ""}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
